var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container"},[_c('Loader',{attrs:{"is-loading":_vm.isLoading}}),_vm._t("default"),_c('img',{ref:"image",attrs:{"loading":"lazy","src":_vm.src,"alt":_vm.source}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }